<template>
  <div class="order-wrapper payment-wrapper" :class="{ 'is-active': openSlideleft }">
    <portal target-el="#filter">
      <primary-filter
        searchText="Search by Indent ID"
        :menuOptions="$checkMenuOptions(bidsMenu)"
        :selectedCategory="selectedCategory"
        @search="searchByOrderId" />
    </portal>
    <div>
      <div class="flex-container page-filter">
        <div class="flex-item">
          <filter-wrapper
            :values="filterTags"
            @openSliderLeft="openSlideleft = !openSlideleft"/>
        </div>
      </div>
      <div class="slideleft_drawer" :class="{ openSlideleft: openSlideleft }">
        <div class="slideleft_content">
          <div class="content">
            <div
              v-infinite-scroll="loadData"
              infinite-scroll-disabled="loadCheck"
              infinite-scroll-throttle-delay="400"
              infinite-scroll-distance="10">
              <bids-header
                :headers="bidsHeader"
                :hideSelectAll="true"
                :noCheckbox="true"
                 />
              <div v-if="isLoading" class="paymentloader"></div>
              <div v-else-if="bids.length === 0" class="emptydiv">
                <div class="paymentempty"></div>
                <div class="emptytext">{{$t('BIDS_NO_BIDS_FOUND')}}</div>
              </div>
              <div v-else>
                <bids-row v-for="(bid,index) in bids"
                  :key="index"
                  :sectionHeader="bidsHeader"
                  :bid="bid"
                  :isFilterClosed="!openSlideleft"
                  @showActions="showActions(bid.order_no)" />
                <div v-if="isPaginating">
                  <Spinner />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="slideleft_menu">
          <sec-filter
            v-if="filterConstant.length > 0"
            :selectedFilters="filterConstant"
            @search="search"
            @updateOption="updateOption"
            @reset="resetApply"
            @clearDate="clearDate" />
        </div>
        <div>
          <drawer
            direction="rtl"
            size="740px"
            class="default-drawer"
            :visible.sync="isDetailsEnabled"
            :modal="true"
            :withHeader="false"
            :append-to-body="true">
            <Link :underline="false" class="nav-close" @click="isDetailsEnabled=false">
              <svgicon name="cancelwhite" width="12" height="12" :original="true" />
            </Link>
            <bids-actions
              v-if="isDetailsEnabled"
              :bid="selectedBid"
              @updateRfq="updateRfq" />
          </Drawer>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  bidsMenu,
  filters,
  bidsHeader, indentMovementTypes } from '@/constants/indentConstants';
import SecFilter from '@common/components/SecFilter';
import SecFilterMixin from '@common/mixins/SecFilterMixin';
import FilterWrapper from '@common/components/FilterWrapperV2';
import BidsHeader from '@common/components/HeaderV2';
import PrimaryFilter from '@/modules/common/PrimaryFilter';
import BidsRow from '@/modules/indents/components/bidsRow';
import BidsActions from '@/modules/indents/components/details/bidsActions';

export default {
  components: {
    BidsHeader,
    SecFilter,
    FilterWrapper,
    PrimaryFilter,
    BidsRow,
    BidsActions,
  },
  data() {
    return {
      bidsMenu,
      filters,
      bidsHeader,
      openSlideleft: false,
      defaultValues: {},
      filterConstant: [],
      loadCheck: true,
      isDetailsEnabled: false,
      selectedBid: null,
      indentMovementTypes,
    };
  },
  mixins: [SecFilterMixin],
  computed: {
    ...mapGetters({
      depots: 'app/depots',
      bids: 'indents/bidsList',
      filter: 'indents/filter',
      hasEmpty: 'indents/hasEmpty',
      isLoading: 'indents/isLoading',
      isPaginating: 'indents/isPaginating',
      otherDepots: 'app/getOtherDepots',
    }),
    selectedCategory() {
      return this.bidsMenu.find(menu => menu.id === 'bids');
    },
  },
  created() {
    this.setDefaults();
    this.loadFilters();
    this.$store.commit('indents/initialReset');
    this.search();
  },
  methods: {
    setDefaults() {
      this.defaultValues.depot = [];
      this.defaultValues.depot.push(this.depots[0] || this.otherDepots[0]);
      this.defaultValues.movement = this.indentMovementTypes[0];
    },
    constructConstantForFilter() {
      const depotList = this.constructDepotGroup(this.depots, this.otherDepots,
        this.defaultValues.depot.map(depot => depot.id));
      this.filterConstant = [
        [
          {
            type: 'MultiSelectGroup',
            category: this.filters.DEPOT,
            tlabel: 'INDENT_DEPOT',
            default: this.defaultValues.depot,
            selected: this.defaultValues.depot,
            list: depotList,
            idLabel: 'id',
            optional: false,
            allowEmpty: false,
            queryParamString: 'depot_id',
            placeholder: 'Select depots',
            selectAllOption: true,
            defaultSelectAll: true,
            search: true,
          },
        ],
        [
          {
            type: 'List',
            category: this.filters.MOVEMENT,
            tlabel: 'INDENT_MOVEMENT',
            default: this.defaultValues.movement,
            selected: this.defaultValues.movement,
            list: this.indentMovementTypes,
            idLabel: 'id',
            queryParamString: 'movement',
          },
        ],
      ];
    },
    resetApply() {
      this.$store.commit('indents/setPage', 1);
      this.resetAll();
      this.search();
    },
    search() {
      this.$store.commit('indents/setPage', 1);
      this.applyFilters();
      this.openSlideleft = false;
      this.loadData();
    },
    searchByOrderId(query) {
      this.orderNumber = query;
      this.$store.commit('indents/setPage', 1);
      this.loadData();
    },
    async loadData() {
      try {
        if ((this.depots.length || this.otherDepots.length)) {
          let filter = this.constructFilterPayload();
          if (filter) {
            filter = Object.assign(filter, this.filter);
            if (this.orderNumber) {
              filter.order_no = this.orderNumber;
            }
            const result = await this.$store.dispatch('indents/bidsFilter', filter);
            if (result.error) {
              this.$errorMessage({ message: result.error });
            }
            this.loadCheck = this.hasEmpty;
          }
        } else {
          this.$errorMessage({ message: this.$getErr('FEILDS_MISSING') });
        }
      } catch (error) {
        this.$errorMessage({ message: this.$getErr('LISTING_FAILS') });
      }
    },
    showActions(orderNo) {
      this.selectedBid = this.bids.find(bid => bid.order_no === orderNo);
      this.isDetailsEnabled = true;
    },
    async updateRfq(data) {
      try {
        const result = await this.$store.dispatch('indents/updateRfq', {
          orderNo: this.selectedBid.order_no, data });
        if (result.error) {
          this.$errorMessage({ message: result.error });
        }
        if (result.data) {
          this.$successMessage({ message: this.$getSuccess('RFQ_UPDATED') });
          this.isDetailsEnabled = false;
        }
        return result;
      } catch (error) {
        return error;
      }
    },
  },
};
</script>
